const state = {
  timeFormat: 24,
  firstDayOfWeek: 0,
  appearance: 'default',
  notificationShow: true,
  notificationBrowser: false,
  notificationSound: false,
};

const getters = {
  settings: (state) => state,
  timeFormat: (state) => state.timeFormat,
  firstDayOfWeek: (state) => state.firstDayOfWeek,
  appearance: (state) => state.appearance,
  notificationShow: (state) => state.notificationShow,
  notificationBrowser: (state) => state.notificationBrowser,
  notificationSound: (state) => state.notificationSound,
};

const mutations = {
  SET_SETTING(state, { key, value }) {
    if (key in state && typeof value === typeof state[key]) {
      state[key] = value;
    }
  },
  SET_ALL_SETTINGS(state, settings) {
    Object.keys(settings).forEach((key) => {
      if (key in state && typeof settings[key] === typeof state[key]) {
        state[key] = settings[key];
      }
    });
  },
  RESET_SETTINGS(state) {
    state.timeFormat = 24;
    state.firstDayOfWeek = 0;
    state.appearance = 'default';
    state.notificationShow = true;
    state.notificationBrowser = false;
    state.notificationSound = false;
  },
};

const actions = {
  loadSettings({ commit }) {
    const savedSettings = localStorage.getItem('settings');
    if (savedSettings) {
      try {
        const parsedSettings = JSON.parse(savedSettings);
        commit('SET_ALL_SETTINGS', parsedSettings);
      } catch (error) {
        console.error('Failed to parse settings from localStorage:', error);
        // Clear corrupted data
        localStorage.removeItem('settings');
      }
    }
  },
  updateSetting({ commit, state }, { key, value }) {
    commit('SET_SETTING', { key, value });
    // Save to localStorage after updating
    localStorage.setItem('settings', JSON.stringify(state));
  },
  updateAllSettings({ commit, state }, settings) {
    commit('SET_ALL_SETTINGS', settings);
    // Save to localStorage after updating
    localStorage.setItem('settings', JSON.stringify(state));
  },
  resetSettings({ commit, state }) {
    commit('RESET_SETTINGS');
    // Save to localStorage after resetting
    localStorage.setItem('settings', JSON.stringify(state));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
